module.exports = __webpack_public_path__ + "static/img/gopay-3-mobile-bg.9e97fb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gopay/gopay-3-mobile-bg.png
// module id = /ADa
// module chunks = 18